import {
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { HourglassIcon } from '@/assets';
import { BackdropImage } from '@/components/ui/backdropImage';

export const Route = createFileRoute('/_auth/(first-login)/invitation-expired')({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <>
      <CardHeader className="gap-space-2xs">
        <CardTitle className="text-heading-lg-semibold">
          { t('invitationExpired.title', { ns: 'auth' }) }
        </CardTitle>
        <CardDescription className="text-body-md-normal">
          { t('invitationExpired.description', { ns: 'auth' }) }
        </CardDescription>
      </CardHeader>

      <CardContent className="flex justify-center pt-space-md pb-space-3xl">
        <BackdropImage src={ HourglassIcon } />
      </CardContent>
    </>
  );
}
